import Auth from './Auth';
import ErrorMessage from './ErrorMessage.json';
import IdleModal from './IdleModal.json';
import Notice from './Notice.json';
import ModalContent from './ModalContent';

export default {
  ...Auth,
  ...ErrorMessage,
  ...IdleModal,
  ...Notice,
  ...ModalContent
};



// WEBPACK FOOTER //
// ./src/i18n/de/components/index.js